// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__e_CGB","header":"MergedInvoice_header___GQAd"};